import PropTypes from 'prop-types';
import { useContext, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

// mantine
import { NavLink } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

// project imports
import DrawerContext from 'contexts/DrawerContext';
import { handleLogout } from 'utils/auth-helpers';
import OTPDialog from 'views/public/signup/dialogs/OTPDialog';
import { radius, semanticColors } from 'theme';

const customizationConfig = {
  basename: '',
  defaultPath: '/',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12
};

// ==============================|| SIDEBAR MENU LIST ITEMS ||============================== //

const NavItem = ({ item, level }) => {
  const { pathname } = useLocation();

  const { leftDrawerOpened: opened } = useContext(DrawerContext);
  const [openOTPAlertDialog, setOpenOTPAlertDialog] = useState(false);

  // if there are multiple pathname then get only the first one
  const mainPath = pathname.split('/').length > 2 ? `/${pathname.split('/')[1]}` : pathname;
  const isNavItemSelected = mainPath === item.url || pathname === item.url;

  const Icon = item.disabled ? IconAlertTriangle : item.icon;

  // Mobile nav close is handled by MainLayout's route-change effect —
  // setting leftDrawerOpened here would corrupt the DESKTOP collapse state.
  const itemHandler = async (id) => {
    if (id === 'logout') {
      await handleLogout();
      window.location.assign('/login');
    }
  };

  const handleClick = (e) => {
    if (item.disabled) {
      e.preventDefault();
      setOpenOTPAlertDialog(true);
      return;
    }
    itemHandler(item.id);
  };

  return (
    <>
      <NavLink
        component={Link}
        to={item.url ? `${customizationConfig.basename}${item.url}` : '#'}
        target={item.target ? '_blank' : '_self'}
        label={opened ? item.title : ''}
        description={item.caption && opened ? item.caption : undefined}
        leftSection={Icon ? <Icon size={20} stroke={1.5} color={isNavItemSelected ? 'white' : semanticColors.text.primary} /> : null}
        active={isNavItemSelected}
        onClick={handleClick}
        style={{
          borderRadius: radius.control,
          marginBottom: 4,
          paddingLeft: level * 24
        }}
        styles={{
          root: {
            '&[dataActive]': {
              backgroundColor: 'var(--mantine-color-coral-6)',
              color: 'white',
              '&:hover': {
                backgroundColor: 'var(--mantine-color-coral-7)'
              }
            },
            '&:not([dataActive]):hover': {
              backgroundColor: semanticColors.surface.raised
            }
          },
          label: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontWeight: isNavItemSelected ? 600 : 400,
            color: isNavItemSelected ? 'white' : semanticColors.text.primary
          },
          section: {
            color: isNavItemSelected ? 'white' : semanticColors.text.primary,
            minWidth: 36
          }
        }}
        variant={isNavItemSelected ? 'filled' : 'subtle'}
        color={isNavItemSelected ? 'coral' : 'gray'}
      />
      <OTPDialog open={openOTPAlertDialog} setOpen={setOpenOTPAlertDialog} navigateOnClose="/my-apps" />
    </>
  );
};

NavItem.propTypes = {
  item: PropTypes.object,
  level: PropTypes.number
};

export default NavItem;
